module.exports = __webpack_public_path__ + "static/img/7.4608f86.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/zh/7.png
// module id = WE3w
// module chunks = 0